// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__P8uBs","spinner-d3wgkg":"Spinner_spinner-d3wgkg__7FVWR"};